import { render, staticRenderFns } from "./partnerRecord.vue?vue&type=template&id=dbc206e8&scoped=true&"
import script from "./partnerRecord.vue?vue&type=script&lang=tsx&"
export * from "./partnerRecord.vue?vue&type=script&lang=tsx&"
import style0 from "./partnerRecord.vue?vue&type=style&index=0&id=dbc206e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc206e8",
  null
  
)

export default component.exports